"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LineStyles = void 0;
exports.getLineStyles = getLineStyles;
exports.getLineStyleSpecs = getLineStyleSpecs;
var LineStyles;
(function (LineStyles) {
    LineStyles[LineStyles["BandA"] = 0] = "BandA";
    LineStyles[LineStyles["BandB"] = 1] = "BandB";
    LineStyles[LineStyles["BandC"] = 2] = "BandC";
})(LineStyles || (exports.LineStyles = LineStyles = {}));
function getLineStyles(colors) {
    return [
        getLineStyleSpecs(LineStyles.BandA, colors),
        getLineStyleSpecs(LineStyles.BandB, colors),
        getLineStyleSpecs(LineStyles.BandC, colors),
    ];
}
function getLineStyleSpecs(lineChartItem, colors) {
    switch (lineChartItem) {
        case LineStyles.BandA:
            return {
                color: colors.Curriculum.ww.bandA || '',
                dash: [0],
                pointStyle: 'circle',
                name: 'band-a',
            };
        case LineStyles.BandB:
            return {
                color: colors.Curriculum.ww.bandB || '',
                dash: [2, 2],
                pointStyle: 'triangle',
                name: 'band-b',
            };
        case LineStyles.BandC:
            return {
                color: colors.Curriculum.ww.bandC || '',
                dash: [7, 4],
                pointStyle: 'rect',
                name: 'band-c',
            };
        default:
            return {
                color: colors.Curriculum.ww.bandA || '',
                dash: [0],
                pointStyle: 'circle',
                name: 'band-a',
            };
    }
}
